import type { SupportedLocale } from '@erp/shared';
export const portalTemplates = {
  de: {
    saveAs: 'Als Vorlage speichern',
    save: 'Speichern',
    saved: 'Vorlage gespeichert.',
    name: 'Name',
    nameRequired: 'Bitte einen Namen eingeben.',
    shared: 'Gemeinsam im Kundenkonto',
    personal: 'Persönlich',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    deleteTitle: 'Vorlage „{{name}}“ löschen?',
    deleteHint: 'Der Warenkorb und vorhandene Bestellungen bleiben erhalten.',
    deleted: 'Vorlage gelöscht.',
    cancel: 'Abbrechen',
    discard: 'Änderungen verwerfen',
    discardHint: 'Ungespeicherte Änderungen gehen verloren.',
    noOrder: 'Eine Vorlage erzeugt keine Bestellung, Reservierung oder Zahlung.',
    saveAddress: 'Lieferadresse mitspeichern',
    address: 'Lieferadresse',
    addresses: 'Lieferadressen laden',
    billingAddress: 'Rechnungsadresse verwenden',
    addressInvalid:
      'Die gespeicherte Lieferadresse ist nicht mehr gültig. Bitte eine gültige Adresse auswählen.',
    addressChanged: 'Die Lieferadresse unterscheidet sich vom gespeicherten Stand.',
    article: 'Artikel',
    articles: 'Artikel',
    quantity: 'Menge',
    remove: 'Entfernen',
    addArticle: 'Artikel oder Gebinde hinzufügen',
    use: 'Verwenden',
    preview: 'Warenkorb vorbereiten',
    comparisonOnly:
      'Gespeicherte Preise dienen nur zum Vergleich. Es gelten die aktuellen Preise und Mengenstaffeln.',
    cartMode: 'Bestehenden Warenkorb',
    ADD: 'Ergänzen',
    REPLACE: 'Ersetzen',
    chooseMode:
      'Wählen Sie Ergänzen oder Ersetzen und laden Sie die Vorschau. Ersetzen entfernt alle bisherigen Warenkorbpositionen.',
    refresh: 'Vorschau aktualisieren',
    apply: 'In den Warenkorb übernehmen',
    applied: 'Warenkorb vorbereitet.',
    stale: 'Die Auswahl wurde geändert. Bitte die Vorschau aktualisieren.',
    merge: 'Vorhanden: {{existing}} + Vorlage: {{added}} = Ergebnis: {{result}}',
    factor: 'Faktor: {{factor}}',
    priceChanged: 'Preis geändert',
    packagingChanged: 'Gebinde geändert',
    previous: 'Bisher:',
    baseUnits: 'Basiseinheiten',
    total: 'Netto:',
    discount: 'Kundenrabatt: {{discount}} %',
    checkoutChecks:
      'Lieferkonditionen, Steuern und Verfügbarkeit werden im regulären Checkout erneut geprüft.',
    help: 'Speichern Sie Warenkörbe oder Bestellungen als Vorlagen. Persönliche Vorlagen sind nur für Sie sichtbar. Portaladministratoren verwalten gemeinsame Vorlagen für Ihr Kundenkonto. Bearbeiten Sie Artikel und Gebinde über Entfernen und Hinzufügen; Favoriten erleichtern die Auswahl.',
    empty:
      'Noch keine Vorlagen. Speichern Sie einen gefüllten Warenkorb oder eine vorhandene Bestellung als Vorlage.',
    conflict:
      'Warenkorb, Vorlage oder aktuelle Daten wurden geändert. Bitte die Vorschau neu laden.',
    invalid: 'Bitte die markierten Positionen prüfen und die Vorschau aktualisieren.',
    issues: {
      PRODUCT_UNAVAILABLE: 'Artikel nicht mehr bestellbar. Bitte die Vorlage bewusst bearbeiten.',
      PACKAGING_UNAVAILABLE: 'Gebinde nicht mehr verfügbar. Bitte die Vorlage bewusst bearbeiten.',
      QUANTITY_INVALID: 'Menge entspricht nicht der Mindestmenge oder dem Mengenschritt.',
      PRICE_UNAVAILABLE: 'Aktueller Preis kann nicht ermittelt werden.',
      STOCK_UNAVAILABLE: 'Die zusammengeführte Menge ist nicht verfügbar.',
    },
  },
  en: {
    saveAs: 'Save as template',
    save: 'Save',
    saved: 'Template saved.',
    name: 'Name',
    nameRequired: 'Please enter a name.',
    shared: 'Shared within customer account',
    personal: 'Personal',
    edit: 'Edit',
    delete: 'Delete',
    deleteTitle: 'Delete template “{{name}}”?',
    deleteHint: 'Your cart and existing orders will be retained.',
    deleted: 'Template deleted.',
    cancel: 'Cancel',
    discard: 'Discard changes',
    discardHint: 'Unsaved changes will be lost.',
    noOrder: 'A template does not create an order, reservation or payment.',
    saveAddress: 'Save delivery address',
    address: 'Delivery address',
    addresses: 'Load delivery addresses',
    billingAddress: 'Use billing address',
    addressInvalid: 'The saved delivery address is no longer valid. Please select a valid address.',
    addressChanged: 'The delivery address differs from the saved version.',
    article: 'Product',
    articles: 'Products',
    quantity: 'Quantity',
    remove: 'Remove',
    addArticle: 'Add product or packaging',
    use: 'Use',
    preview: 'Prepare cart',
    comparisonOnly:
      'Saved prices are comparison values only. Current prices and quantity tiers apply.',
    cartMode: 'Existing cart',
    ADD: 'Add',
    REPLACE: 'Replace',
    chooseMode:
      'Choose Add or Replace and load the preview. Replace removes all existing cart items.',
    refresh: 'Refresh preview',
    apply: 'Apply to cart',
    applied: 'Cart prepared.',
    stale: 'The selection changed. Please refresh the preview.',
    merge: 'Existing: {{existing}} + Template: {{added}} = Result: {{result}}',
    factor: 'Factor: {{factor}}',
    priceChanged: 'Price changed',
    packagingChanged: 'Packaging changed',
    previous: 'Previously:',
    baseUnits: 'base units',
    total: 'Net:',
    discount: 'Customer discount: {{discount}} %',
    checkoutChecks:
      'Delivery terms, taxes and availability are checked again in the regular checkout.',
    help: 'Save carts or orders as templates. Personal templates are visible only to you. Portal administrators manage shared templates for your customer account. Change products and packaging by removing and adding selections; favorites make selection easier.',
    empty: 'No templates yet. Save a populated cart or an existing order as a template.',
    conflict: 'The cart, template or current data changed. Please refresh the preview.',
    invalid: 'Please check the highlighted items and refresh the preview.',
    issues: {
      PRODUCT_UNAVAILABLE: 'Product no longer orderable. Please explicitly edit the template.',
      PACKAGING_UNAVAILABLE: 'Packaging no longer available. Please explicitly edit the template.',
      QUANTITY_INVALID: 'Quantity does not meet the minimum or order step.',
      PRICE_UNAVAILABLE: 'Current price could not be determined.',
      STOCK_UNAVAILABLE: 'The merged quantity is not available.',
    },
  },
  fr: {
    saveAs: 'Enregistrer comme modèle',
    save: 'Enregistrer',
    saved: 'Modèle enregistré.',
    name: 'Nom',
    nameRequired: 'Veuillez saisir un nom.',
    shared: 'Partagé dans le compte client',
    personal: 'Personnel',
    edit: 'Modifier',
    delete: 'Supprimer',
    deleteTitle: 'Supprimer le modèle « {{name}} » ?',
    deleteHint: 'Le panier et les commandes existantes sont conservés.',
    deleted: 'Modèle supprimé.',
    cancel: 'Annuler',
    discard: 'Abandonner les modifications',
    discardHint: 'Les modifications non enregistrées seront perdues.',
    noOrder: 'Un modèle ne crée ni commande, ni réservation, ni paiement.',
    saveAddress: 'Enregistrer l’adresse de livraison',
    address: 'Adresse de livraison',
    addresses: 'Charger les adresses de livraison',
    billingAddress: 'Utiliser l’adresse de facturation',
    addressInvalid: 'L’adresse enregistrée n’est plus valide. Veuillez choisir une adresse valide.',
    addressChanged: 'L’adresse de livraison diffère de la version enregistrée.',
    article: 'Article',
    articles: 'Articles',
    quantity: 'Quantité',
    remove: 'Retirer',
    addArticle: 'Ajouter un article ou un conditionnement',
    use: 'Utiliser',
    preview: 'Préparer le panier',
    comparisonOnly:
      'Les prix enregistrés servent uniquement de comparaison. Les prix et paliers actuels s’appliquent.',
    cartMode: 'Panier existant',
    ADD: 'Compléter',
    REPLACE: 'Remplacer',
    chooseMode:
      'Choisissez Compléter ou Remplacer puis chargez l’aperçu. Remplacer retire toutes les lignes du panier actuel.',
    refresh: 'Actualiser l’aperçu',
    apply: 'Appliquer au panier',
    applied: 'Panier préparé.',
    stale: 'La sélection a changé. Veuillez actualiser l’aperçu.',
    merge: 'Existant : {{existing}} + Modèle : {{added}} = Résultat : {{result}}',
    factor: 'Facteur : {{factor}}',
    priceChanged: 'Prix modifié',
    packagingChanged: 'Conditionnement modifié',
    previous: 'Auparavant :',
    baseUnits: 'unités de base',
    total: 'Net :',
    discount: 'Remise client : {{discount}} %',
    checkoutChecks:
      'Les conditions de livraison, les taxes et la disponibilité sont revérifiées lors de la commande normale.',
    help: 'Enregistrez des paniers ou commandes comme modèles. Vos modèles personnels ne sont visibles que par vous. Les administrateurs du portail gèrent les modèles partagés du compte client. Retirez et ajoutez des articles pour changer les conditionnements ; les favoris facilitent la sélection.',
    empty: 'Aucun modèle. Enregistrez un panier rempli ou une commande existante comme modèle.',
    conflict: 'Le panier, le modèle ou les données actuelles ont changé. Actualisez l’aperçu.',
    invalid: 'Vérifiez les lignes signalées et actualisez l’aperçu.',
    issues: {
      PRODUCT_UNAVAILABLE: 'Article non commandable. Veuillez modifier explicitement le modèle.',
      PACKAGING_UNAVAILABLE:
        'Conditionnement indisponible. Veuillez modifier explicitement le modèle.',
      QUANTITY_INVALID: 'Quantité incompatible avec le minimum ou le pas de commande.',
      PRICE_UNAVAILABLE: 'Le prix actuel ne peut pas être déterminé.',
      STOCK_UNAVAILABLE: 'La quantité regroupée est indisponible.',
    },
  },
  es: {
    saveAs: 'Guardar como plantilla',
    save: 'Guardar',
    saved: 'Plantilla guardada.',
    name: 'Nombre',
    nameRequired: 'Introduzca un nombre.',
    shared: 'Compartida en la cuenta del cliente',
    personal: 'Personal',
    edit: 'Editar',
    delete: 'Eliminar',
    deleteTitle: '¿Eliminar la plantilla «{{name}}»?',
    deleteHint: 'Se conservan el carrito y los pedidos existentes.',
    deleted: 'Plantilla eliminada.',
    cancel: 'Cancelar',
    discard: 'Descartar cambios',
    discardHint: 'Se perderán los cambios sin guardar.',
    noOrder: 'Una plantilla no genera pedidos, reservas ni pagos.',
    saveAddress: 'Guardar dirección de entrega',
    address: 'Dirección de entrega',
    addresses: 'Cargar direcciones de entrega',
    billingAddress: 'Usar dirección de facturación',
    addressInvalid: 'La dirección guardada ya no es válida. Seleccione una dirección válida.',
    addressChanged: 'La dirección de entrega difiere de la versión guardada.',
    article: 'Artículo',
    articles: 'Artículos',
    quantity: 'Cantidad',
    remove: 'Quitar',
    addArticle: 'Añadir artículo o envase',
    use: 'Usar',
    preview: 'Preparar carrito',
    comparisonOnly:
      'Los precios guardados solo sirven para comparar. Se aplican los precios y tramos actuales.',
    cartMode: 'Carrito existente',
    ADD: 'Añadir',
    REPLACE: 'Reemplazar',
    chooseMode:
      'Elija Añadir o Reemplazar y cargue la vista previa. Reemplazar elimina todas las posiciones actuales del carrito.',
    refresh: 'Actualizar vista previa',
    apply: 'Aplicar al carrito',
    applied: 'Carrito preparado.',
    stale: 'La selección ha cambiado. Actualice la vista previa.',
    merge: 'Existente: {{existing}} + Plantilla: {{added}} = Resultado: {{result}}',
    factor: 'Factor: {{factor}}',
    priceChanged: 'Precio modificado',
    packagingChanged: 'Envase modificado',
    previous: 'Antes:',
    baseUnits: 'unidades base',
    total: 'Neto:',
    discount: 'Descuento del cliente: {{discount}} %',
    checkoutChecks:
      'Las condiciones de entrega, los impuestos y la disponibilidad se revisan de nuevo en el proceso normal de pedido.',
    help: 'Guarde carritos o pedidos como plantillas. Solo usted puede ver las personales. Los administradores del portal gestionan las compartidas de su cuenta. Quite y añada artículos para cambiar envases; los favoritos facilitan la selección.',
    empty:
      'No hay plantillas. Guarde un carrito con artículos o un pedido existente como plantilla.',
    conflict:
      'El carrito, la plantilla o los datos actuales han cambiado. Actualice la vista previa.',
    invalid: 'Revise las posiciones marcadas y actualice la vista previa.',
    issues: {
      PRODUCT_UNAVAILABLE:
        'Artículo no disponible para pedidos. Edite la plantilla explícitamente.',
      PACKAGING_UNAVAILABLE: 'Envase no disponible. Edite la plantilla explícitamente.',
      QUANTITY_INVALID: 'La cantidad no cumple el mínimo o el incremento.',
      PRICE_UNAVAILABLE: 'No se puede determinar el precio actual.',
      STOCK_UNAVAILABLE: 'La cantidad combinada no está disponible.',
    },
  },
  tr: {
    saveAs: 'Şablon olarak kaydet',
    save: 'Kaydet',
    saved: 'Şablon kaydedildi.',
    name: 'Ad',
    nameRequired: 'Lütfen bir ad girin.',
    shared: 'Müşteri hesabında paylaşılan',
    personal: 'Kişisel',
    edit: 'Düzenle',
    delete: 'Sil',
    deleteTitle: '“{{name}}” şablonu silinsin mi?',
    deleteHint: 'Sepet ve mevcut siparişler korunur.',
    deleted: 'Şablon silindi.',
    cancel: 'İptal',
    discard: 'Değişiklikleri at',
    discardHint: 'Kaydedilmemiş değişiklikler kaybolur.',
    noOrder: 'Şablon sipariş, rezervasyon veya ödeme oluşturmaz.',
    saveAddress: 'Teslimat adresini kaydet',
    address: 'Teslimat adresi',
    addresses: 'Teslimat adreslerini yükle',
    billingAddress: 'Fatura adresini kullan',
    addressInvalid: 'Kayıtlı teslimat adresi artık geçerli değil. Lütfen geçerli bir adres seçin.',
    addressChanged: 'Teslimat adresi kayıtlı sürümden farklı.',
    article: 'Ürün',
    articles: 'Ürünler',
    quantity: 'Miktar',
    remove: 'Kaldır',
    addArticle: 'Ürün veya ambalaj ekle',
    use: 'Kullan',
    preview: 'Sepeti hazırla',
    comparisonOnly:
      'Kayıtlı fiyatlar yalnızca karşılaştırma içindir. Güncel fiyatlar ve miktar kademeleri geçerlidir.',
    cartMode: 'Mevcut sepet',
    ADD: 'Ekle',
    REPLACE: 'Değiştir',
    chooseMode:
      'Ekle veya Değiştir seçeneğini seçip önizlemeyi yükleyin. Değiştir tüm mevcut sepet kalemlerini kaldırır.',
    refresh: 'Önizlemeyi yenile',
    apply: 'Sepete uygula',
    applied: 'Sepet hazırlandı.',
    stale: 'Seçim değişti. Lütfen önizlemeyi yenileyin.',
    merge: 'Mevcut: {{existing}} + Şablon: {{added}} = Sonuç: {{result}}',
    factor: 'Katsayı: {{factor}}',
    priceChanged: 'Fiyat değişti',
    packagingChanged: 'Ambalaj değişti',
    previous: 'Önceki:',
    baseUnits: 'temel birim',
    total: 'Net:',
    discount: 'Müşteri indirimi: % {{discount}}',
    checkoutChecks:
      'Teslimat koşulları, vergiler ve kullanılabilirlik normal sipariş adımında yeniden kontrol edilir.',
    help: 'Sepetleri veya siparişleri şablon olarak kaydedin. Kişisel şablonlar yalnızca size görünür. Portal yöneticileri müşteri hesabınızın paylaşılan şablonlarını yönetir. Ambalaj değiştirmek için ürünleri kaldırıp ekleyin; favoriler seçimi kolaylaştırır.',
    empty: 'Henüz şablon yok. Dolu bir sepeti veya mevcut siparişi şablon olarak kaydedin.',
    conflict: 'Sepet, şablon veya güncel veriler değişti. Önizlemeyi yenileyin.',
    invalid: 'İşaretli kalemleri kontrol edip önizlemeyi yenileyin.',
    issues: {
      PRODUCT_UNAVAILABLE: 'Ürün artık sipariş edilemiyor. Şablonu açıkça düzenleyin.',
      PACKAGING_UNAVAILABLE: 'Ambalaj artık mevcut değil. Şablonu açıkça düzenleyin.',
      QUANTITY_INVALID: 'Miktar asgari miktara veya sipariş adımına uymuyor.',
      PRICE_UNAVAILABLE: 'Güncel fiyat belirlenemedi.',
      STOCK_UNAVAILABLE: 'Birleştirilmiş miktar mevcut değil.',
    },
  },
} as const satisfies Record<SupportedLocale, unknown>;
